import { GET_RACE_NUM, SET_RACE_NUM } from "../constants/race-number-constants";

export const getRaceNum = () => ({
  type: GET_RACE_NUM,
});

export const setRaceNum = (num) => ({
  type: SET_RACE_NUM,
  num,
});
